import React, { useEffect, useRef, useState } from "react";
import CustomSwitch from "../../../components/customSwitch/CustomSwitch";
import {
  BUTTON_BG_COLOR,
  LIGHT_TEXT_COLOR,
  WHITE_COLOR,
} from "../../../resources/colorsManager";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { MdDelete } from "react-icons/md";
import "./index.css";
export const RowContainer = ({ title, value, style }) => {
  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          ...style,
        }}
      >
        <p
          style={{
            fontSize: 12,
            color: LIGHT_TEXT_COLOR,
            width: "50%",
            padding: 0,
            margin: 0,
          }}
        >
          {title}
        </p>
        <p
          style={{
            fontSize: 12,
            fontWeight: "550",
            textAlign: "left",
            width: "50%",
            padding: 0,
            margin: 0,
            // wordBreak: "break-all",
          }}
        >
          {value}
        </p>
      </div>
    </>
  );
};
function ScheduleContainer({
  name,
  email,
  createdOn,
  frequency,
  type,
  switchDefaultValue,
  id,
  onClickChange,
  data,
  onClickDelete,
}) {
  const [openDelete, setOpenDelete] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event?.target)) {
      setOpenDelete(false);
    }
  };
  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("mousedown", handleClickOutside());
    };
  }, [ref]);

  return (
    <div
      style={{
        border: `1px solid ${BUTTON_BG_COLOR}`,
        minWidth: 200,
        maxWidth: 300,
        minHeight: 150,
        maxHeight: 220,
        borderRadius: 30,
        padding: "10px 20px",
        opacity: !switchDefaultValue ? 0.5 : 1,
        width: "100%",
        margin: "0px 10px 10px 10px",
        boxSizing: "border-box",
      }}
      key={id}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
          alignItems: "center",
        }}
      >
        <p
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          {name
            ? name.length > 15
              ? name.substring(0, 15) + "..."
              : name
            : `Scheduler ${id + 1}`}
        </p>
        <CustomSwitch
          onChange={() => {
            onClickChange(data);
          }}
          value={switchDefaultValue}
          defaultChecked={switchDefaultValue}
        />
      </div>
      <RowContainer
        title={"Email ID:"}
        value={
          email
            ? email.length > 22
              ? email.substring(0, 22) + "..."
              : email
            : "N/A"
        }
      />
      <RowContainer
        title={"Created On:"}
        value={createdOn ? createdOn : "02-FEB-2022"}
      />
      <RowContainer
        title={"Frequency:"}
        value={frequency ? frequency : "Daily"}
      />
      <RowContainer
        title={"Type:"}
        value={type ? type : "Transaction"}
        style={{
          marginBottom: 0,
        }}
      />

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          position: "relative",
        }}
        ref={ref}
      >
        <BiDotsVerticalRounded
          color="dodgerblue"
          onClick={() => {
            setOpenDelete(!openDelete);
          }}
          style={{
            cursor: switchDefaultValue && "pointer",
          }}
        />
        {/* //openDelete && switchDefaultValue */}
        {openDelete && switchDefaultValue && (
          <div
            style={{
              border: "1px solid dodgerblue",
              position: "absolute",
              zIndex: 1000,
              marginTop: 20,
              backgroundColor: WHITE_COLOR,
              maxWidth: 100,
              borderRadius: 4,
              height: 50,
              padding: "5px 0px",
            }}
          >
            <div
              style={{
                zIndex: 1000,
                display: "flex",
                width: "100%",
                cursor: "pointer",
                alignItems: "center",
                justifyContent: "center",
                padding: "0px 6px",
              }}
              onClick={() => onClickDelete(data)}
              className="sub-div"
            >
              <MdDelete color="#7F7F7F" style={{}} size={18} />{" "}
              <p
                style={{
                  fontSize: 14,
                  padding: 0,
                  margin: 0,
                  color: "#7F7F7F",
                  marginLeft: 5,
                }}
              >
                Delete
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ScheduleContainer;
